export const ReportsDynamictableData = [
  {
    id: 'IRRT1',
    name: 'NewAssetAdded',
    text: 'NewAssetAdded',
  },
  {
    id: 'IRRT2',
    name: 'CurrentMonthAssetCANMovement',
    text: 'CurrentMonthAssetCANMovement',
  },
  {
    id: 'IRRT3',
    name: 'PendingReturnsFromBorrowers',
    text: 'PendingReturnsFromBorrowers',
  },
  {
    id: 'IRRT4',
    name: 'AssetsCleaned',
    text: 'AssetsCleaned',
  },
  {
    id: 'IRRT5',
    name: 'AssetsScheduledForCleaning',
    text: 'AssetsScheduledForCleaning',
  },
  {
    id: 'IRRT6',
    name: 'DigitalizationPriority',
    text: 'DigitalizationPriority',
  },
];
export const InwardTableDynamictableData = [
  {
    id: 'OIDYT2',
    name: 'Verify',
  },
  {
    id: 'OIDYT3',
    name: 'Approve',
  },
  {
    id: 'OIDYT4',
    name: 'Picker Assign',
  },
  {
    id: 'OIDYT5',
    name: 'Move To Vault',
  },
  {
    id: 'OIDYT6',
    name: 'AssetsScheduledForCleaning',
  },
];
export const ReportTableDynamictableData = [
  {
    id: 'ORDYT1',
    name: 'Received',
  },
  {
    id: 'ORDYT2',
    name: 'WaitingForApproval',
  },
  {
    id: 'ORDYT3',
    name: 'Approved',
  },
  {
    id: 'ORDYT4',
    name: 'InProgress',
  },
  {
    id: 'ORDYT5',
    name: 'Ready',
  },
  {
    id: 'ORDYT6',
    name: 'Delivered',
  },
  {
    id: 'ORDYT7',
    name: 'Returned',
  },
];
